import type { Subscription } from 'stockblocks-client';

// Recurly subscriptions have no legacy `id`, and the legacy upgrade page looks subscriptions up by `uniqueId`.
export function getUpgradeSubscriptionId(subscription: Subscription | null | undefined): string | null {
    if (!subscription) {
        return null;
    }
    return (subscription.isLegacy ? subscription.uniqueId : subscription.recurlySubscriptionUuid) || null;
}
